const React = require("react");
const {augmentHOCWrapper} = require("../util/HOCUtil");
const RouterContext = require("../top/RouterContext").default;

module.exports = augmentHOCWrapper(function(Component) {
	class SetURLWrapper extends React.Component {
		static displayName = "SetURL:" + Component.displayName;
		static contextType = RouterContext;

		setURL = (href, options) => {
			if (!this.context) {
				return;
			}

			this.context.setURL(href, options);
		};

		render() {
			return <Component {...this.props} setURL={this.setURL} />;
		}
	}

	return SetURLWrapper;
});
